import { Component, OnInit, Inject } from '@angular/core';
import { UserService } from '../../../../../app/shared/services/user.service';
import { ManageEquipmentService } from '../../../../../app/modules/manage-equipment/manage-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../../../app/shared/services/loading.service';
import { EquipmentForSelectionVM, EquipmentRanges } from '../../custom-eval.model';
import { CustomEvalService } from '../../custom-eval.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-custom-eval-delete-confirm',
  templateUrl: './custom-eval-delete-confirm.component.html',
  styleUrls: ['./custom-eval-delete-confirm.component.scss']
})
export class CustomEvalDeleteConfirmComponent implements OnInit {
  selectedEquipment:EquipmentForSelectionVM[]=[]
  EquipmentRanges:EquipmentRanges[]=[];
  constructor(private _user: UserService,
    private _evalService: CustomEvalService,
    public dialogRef: MatDialogRef<CustomEvalDeleteConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
    private _loading: LoadingService) { }

  ngOnInit() {

    console.log("data", this.data)
    this.selectedEquipment = this.data.selectedEquipment;
  
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }

  
}
